import { Component, Renderer2 } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Keyboard } from '@ionic-native/keyboard';
// import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { AbstractPage } from '../pages/_com/abstract-page';

@Component({
  templateUrl: 'app.html'
})
export class MyApp extends AbstractPage{
  // rootPage:any = TabsPage;
  rootPage:any = LoginPage;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private keyboard: Keyboard, private renderer2: Renderer2) {
    super();
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      keyboard.hideFormAccessoryBar(false);

      let html = document.getElementsByTagName('html').item(0);
      this.keyboard.onKeyboardHide().subscribe(() => {
        this.renderer2.setStyle(html, 'height', '101vh')
      });
      this.keyboard.onKeyboardShow().subscribe(() => {
        this.renderer2.setStyle(html, 'height', 'auto')
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts